module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.episode) ? _c('article', {
    staticClass: "page"
  }, [_c('hero', {
    attrs: {
      "episode": _vm.episode,
      "comments": _vm.episode.comments.length
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "postContent"
  }, [_c('div', {
    staticClass: "container",
    domProps: {
      "innerHTML": _vm._s(_vm.episodeContent)
    }
  }), _vm._v(" "), _c('footer', {
    staticClass: "episodeFooter container"
  }, [(_vm.episode.sponsors) ? _c('div', {
    staticClass: "episodeSponsors"
  }, [_c('h3', [_vm._v("Sponsors for this Episode")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.episode.sponsors)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.episode.tags || _vm.topics) ? _c('div', {
    staticClass: "topicsTags"
  }, [(_vm.topics && _vm.topics.length) ? _c('div', [_c('h5', [_vm._v("Topics")]), _vm._v(" "), _c('p', _vm._l((_vm.topics), function(topic, index) {
    return _c('span', [_c('router-link', {
      attrs: {
        "to": '/category/' + topic.slug
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(topic.name)
      }
    })]), _vm._v(" "), ((index + 1) < _vm.topics.length) ? _c('span', {
      staticClass: "sep"
    }, [_vm._v(" • ")]) : _vm._e()], 1)
  }))]) : _vm._e(), _vm._v(" "), (_vm.episode.tags && _vm.episode.tags.length) ? _c('div', [_c('h5', [_vm._v("Tags")]), _vm._v(" "), _c('p', _vm._l((_vm.episode.tags), function(tag, index) {
    return _c('span', [_c('router-link', {
      attrs: {
        "to": '/tag/' + tag.slug
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(tag.name)
      }
    })]), _vm._v(" "), ((index + 1) < _vm.episode.tags.length) ? _c('span', {
      staticClass: "sep"
    }, [_vm._v(" • ")]) : _vm._e()], 1)
  }))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.episode.ctaQuestion || _vm.episode.ctaDescription) ? _c('div', {
    staticClass: "episodeCta"
  }, [(_vm.episode.ctaQuestion) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.episode.ctaQuestion)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.episode.ctaDescription) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.episode.ctaDescription)
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.episode.transcript) ? _c('div', {
    staticClass: "transcript"
  }, [_c('h2', [_vm._v("Podcast Transcript")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.episodeTranscript)
    }
  }), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        _vm.transcriptExpanded = !_vm.transcriptExpanded
      }
    }
  }, [_vm._v(_vm._s(_vm.transcriptExpanded ? 'Show Less' : 'Show More'))])])]) : _vm._e()])]), _vm._v(" "), _c('section', {
    staticClass: "postContent commentsContent"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('comments', {
    attrs: {
      "comments": _vm.episode.comments,
      "postId": _vm.episode.id
    }
  })], 1)])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f22c0cda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Episode.vue
// module id = 805
// module chunks = 1